// extracted by mini-css-extract-plugin
export var footer = "_qr-0";
export var inherit = "_qr-1";
export var input = "_qr-2";
export var modalContent = "_qr-3";
export var quillEditor = "_qr-4";
export var subtitle = "_qr-5";